import { Navigate } from "react-router-dom";
import React from "react"; 
import { Loader } from "./adminRoutes";
import VerifySamlSso from "../views/Login/VerifySamlSso";
import Logout from "../views/Logout";
import SamlError from "../views/Error/SamlError";
import SamlConfigTest from "../views/Login/SamlConfigTest";

const Login = React.lazy(() => import("../views/Login"));
const Authenticator = React.lazy(() => import("../views/Login/Authenticator"));
const VerifySSO = React.lazy(() => import("../views/Login/VerfiySSO"));
const CreatePassword = React.lazy(() =>import("../views/Login/CreatePassword"));
const ForgotPassword = React.lazy(() =>import("../views/Login/ForgotPassword"));
const LinkExpired = React.lazy(() => import("../views/Login/LinkExpired"));
const SignIn = React.lazy(() => import("../views/Login/SignIn"));
const NoAccess = React.lazy(() => import("../views/Noaccess"));
const PageNotFound = React.lazy(() => import("../views/NotFound"));
const ResetPassword = React.lazy(() => import("../views/Login/ResetPassword"));
const CheckInvitationExpiry = React.lazy(() =>import("../components/CheckInvitationExpiry"));
const PdfView = React.lazy(() => import("../components/common/Pdfview"));

 
export const nonAuthRoutes = [
  {
    path: "create-password",
    element: (
      <React.Suspense fallback={<Loader />}>
        <Login>
          <CheckInvitationExpiry>
            <CreatePassword />
          </CheckInvitationExpiry>
        </Login>
      </React.Suspense>
    ),
    title: "Create Password",
    subTitle:"",
    permissions: ["*"],
  },
  {
    path: "link-expired",
    element: (
      <React.Suspense fallback={<Loader />}>
        <Login>
          <LinkExpired />
        </Login>
      </React.Suspense>
    ),
    title: "link-expired",
    subTitle:"",
    permissions: ["*"],
  },
  {
    path: "login",
    element: (
      <React.Suspense fallback={<Loader />}>
        <Login>
          <SignIn />
        </Login>
      </React.Suspense>
    ),
    title: "Sign In",
    subTitle:"",
    permissions: ["*"],
  },
  {
    path: "forgot-password",
    element: (
      <React.Suspense fallback={<Loader />}>
        <Login>
          <ForgotPassword />
        </Login>
      </React.Suspense>
    ),
    title: "forgot-password",
    subTitle:"",
    permissions: ["*"],
  },
  {
    path: "reset-password",
    element: (
      <React.Suspense fallback={<Loader />}>
        <Login>
          <ResetPassword />
        </Login>
      </React.Suspense>
    ),
    title: "Reset Password",
    subTitle:"",
    permissions: ["*"],
  },
  {
    path: "authenticator",
    element: (
      <React.Suspense fallback={<Loader />}>
        <Login>
          <Authenticator />
        </Login>
      </React.Suspense>
    ),
    title: "Authenticate",
    subTitle:"",
    permissions: ["*"],
  },
  {
    path: "verify-sso",
    element: (
      <React.Suspense fallback={<Loader />}>
        <Login>
          <VerifySSO />
        </Login>
      </React.Suspense>
    ),
    title: "verify-sso",
    subTitle:"",
    permissions: ["*"],
  },
  {
    path: "verify-saml-sso",
    element: (
      <React.Suspense fallback={<Loader />}>
        <Login>
          <VerifySamlSso />
        </Login>
      </React.Suspense>
    ),
    title: "verify-saml-sso",
    subTitle:"",
    permissions: ["*"],
  },
  {
    path: "saml-error",
    element: (
      <React.Suspense fallback={<Loader />}>
          <SamlError />
      </React.Suspense>
    ),
    title: "saml-error",
    subTitle:"",
    permissions: ["*"],
  },
  {
    path: "saml-config-test",
    element: (
      <React.Suspense fallback={<Loader />}>
        <SamlConfigTest />
      </React.Suspense>
    ),
    title: "saml-config-test",
    subTitle: "",
    permissions: ["*"],
  },
  {
    path: "logout",
    element: (
      <React.Suspense fallback={<Loader />}>
        <Logout />
      </React.Suspense>
    ),
    title: "Logout",
    subTitle:"",
    permissions: ["*"],
  },
  
  {
    path: "no-access",
    element: (
      <React.Suspense fallback={<Loader />}>
        <NoAccess page="no-access" />
      </React.Suspense>
    ),
    title: "No access",
    subTitle:"",
    permissions: ["*"],
  },
  
  {
    path: "/",
    element: <Navigate to="login" />,
    title: "Home",
    subTitle:"",
    permissions: ["*"],
  },
  {
    path: "*",
    element: (
      <React.Suspense fallback={<Loader />}>
        <PageNotFound />
      </React.Suspense>
    ),
    title: "No Access",
    subTitle:"",
    permissions: ["*"],
  },
  {
    path: "static-content",
    element: (
      <React.Suspense fallback={<Loader />}>
        <PdfView />
      </React.Suspense>
    ),
    title: "static-view",
    subTitle:"",
    permissions: ["*"],
  },
 
];
